@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.linkshare

import com.narbase.letsgo.router.EndPoint

object SetLinkShareRewardsDisabledEndpoint :
    EndPoint<SetLinkShareRewardsDisabledEndpoint.Request, SetLinkShareRewardsDisabledEndpoint.Response>() {
    class Request(
        val shareToken: String,
        val disabled: Boolean,
    )

    class Response(
        val affectedRows: Int,
    )
}
